import React, { useState, useEffect } from 'react'
import { Formik, FieldArray } from 'formik'
import { Row, Col } from 'react-bootstrap'
import { Button } from '@abroad/components'
import InputField from '../form/InputField'
import QuestHOC from './QuestHOC'

const QuestPackingList = ({
  questDetail,
  updateQuestDetails,
  isFormSubmitting,
}) => {
  const [initialValues, setInitialValues] = useState({
    packingList: questDetail?.packingList || [],
  })

  useEffect(() => {
    setInitialValues({
      packingList: questDetail?.packingList || [],
    })
  }, [questDetail])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { resetForm }) => {
        const filteredValues = {
          packingList: values.packingList.filter(
            (item) => item.item && item.item.trim() !== '',
          ),
        }
        updateQuestDetails(filteredValues)
        resetForm({ values: filteredValues })
      }}>
      {({ values, setFieldValue, handleSubmit, resetForm }) => (
        <form onSubmit={handleSubmit}>
          <Row>
            <Col lg={12}>
              <h3 className='s3'>Packing List</h3>
              <FieldArray name='packingList'>
                {({ push, remove }) => (
                  <div>
                    {values.packingList?.length > 0 &&
                      values.packingList.map((item, index) => (
                        <div className='mt-4' key={index}>
                          <div className='d-flex justify-content-between align-items-center'>
                            <label className='input-lable'>
                              PACKING ITEM {index + 1}
                            </label>
                            {values.packingList?.length > 1 && (
                              <p
                                className='deleteBtn cursor-pointer'
                                onClick={() => remove(index)}>
                                Delete
                              </p>
                            )}
                          </div>
                          <InputField
                            name={`packingList.${index}.item`}
                            placeholder='Packing Item'
                            showErrorMessage={false}
                            displayFlex={false}
                            inputClasses='w-100 sa2 selection-field input-typo text-dark-900 text-capitalize'
                          />
                        </div>
                      ))}
                    <Button
                      variant='gray'
                      className='px-4 py-3 abroad-blue mt-3'
                      type='button'
                      onClick={() => push({ item: '' })}>
                      ADD PACKING ITEM
                    </Button>
                  </div>
                )}
              </FieldArray>
            </Col>
          </Row>
          <div className='d-flex justify-content-end mt-5'>
            <Button
              disabled={isFormSubmitting}
              onClick={() => resetForm({ values: initialValues })}
              variant='outline-dark'
              className='mr-3 text-uppercase s8'
              type='button'>
              Cancel
            </Button>
            <Button
              isLoading={isFormSubmitting}
              disabled={isFormSubmitting}
              className='save-btn-fixed-width'
              type='submit'
              variant='saffron'>
              <span>Save</span>
            </Button>
          </div>
        </form>
      )}
    </Formik>
  )
}

export default QuestHOC(QuestPackingList)
